import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../../pages/Dashboard/Sidebar";
import Routers from "../../routers/Routers";
import { Toaster } from "react-hot-toast";
const Layout = () => {
  const location = useLocation();

  return (
    <div className="flex h-screen">
      <Toaster />
      {location.pathname.startsWith("/dashboard") && <Sidebar />}
      <div className="flex-1 overflow-y-auto">
        <Routers />
      </div>
    </div>
  );
};

export default Layout;
